import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { usePoliciesSelect } from '@/context/policiesContext';
import { SelectPolicyTable } from '@/components/tables/SelectPolicyTable';

// One-way sync: policies context is source of truth → formik.policies
export const PolicySelectionSync = ({ statusId, typeId }) => {
	const formik = useFormikContext();
	const { selectedPolicies } = usePoliciesSelect();

	useEffect(() => {
		const contextPolicies = selectedPolicies || [];
		const currentPolicies = formik.values.policies || [];
		// Check if the policies are out of sync by comparing all IDs
		const contextIds = contextPolicies.map((policy) => policy?.Id).join('|');
		const currentIds = currentPolicies.map((policy) => policy?.Id).join('|');
		const isOutOfSync = contextIds !== currentIds;

		if (isOutOfSync) {
			formik.setFieldValue('policies', contextPolicies);
		}
	}, [selectedPolicies, formik.values.policies]);

	return (
		<SelectPolicyTable clientId={formik.values.clientId} statusId={statusId} typeId={typeId} />
	);
};
